import styled from 'styled-components';

export const TimedealSwipeWrapperStyle = styled.div``;

export const TimedealProductCardWrapper = styled.div`
  width: 100%;
  margin-top: 17px;
`;

export const TimedealImageStyle = styled.div<{ src: string }>`
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: calc(100% * 2 / 3);
  background: ${({ src }) => `no-repeat center / cover url(${src})`};
`;

export const TimedealProductCardInfoStyle = styled.div`
  margin-top: 8px;
  display: flex;
  justify-content: space-between;
  color: black;
  .product-info {
    display: flex;
    flex-direction: column;

    .store-name {
      font-size: 12px;
      font-weight: 700;
    }
    .product-name {
      font-size: 10px;
      font-weight: 500;
      margin-top: 5px;
    }
    .price-info {
      display: flex;
      align-items: center;
      gap: 5px;
      margin-top: 7px;
      .discount-rate {
        font-size: 18px;
        font-weight: 700;
        color: #5727de;
      }
      .sales-price {
        font-size: 18px;
        font-weight: 700;
      }
      .origin-price {
        font-size: 15px;
        font-weight: 500;
        text-decoration-line: line-through;
        color: #d9d9d9;
      }
    }
  }

  .today-delivery {
    width: 52px;
    margin-top: 4px;
  }
`;
